<header>
  <mat-toolbar color="primary">
    <mat-toolbar-row class="toolbar-row content-container">
      <img class="logo" width="auto" height="50" [alt]="title" [src]="logo" />
      <dh-navigation [isAdmin]="isAdmin" [isGuideOrAdmin]="isGuideOrAdmin"
                     [isGuide]="isGuide" [isStudent]="isStudent"
                     [isViewSkillsStackAccess]="isViewSkillsStackAccess"
                     [studentId]="studentFacade.studentId$ | async"></dh-navigation>
      <div class="spacer"></div>
      <ng-content></ng-content>
      <dh-profile-menu [background]="background"
                       [image]="image"
                       (openProfileSettings)="onOpenProfileSettings()"
                       (logout)="onLogout()"
      ></dh-profile-menu>
    </mat-toolbar-row>
  </mat-toolbar>
</header>
